import React, {useEffect} from "react";
import "./OnlineOff.scss";
import SwiperId from "react-id-swiper";
import {useHistory} from "react-router-dom";
import {useBasket, useDispatchBasket} from "../../hooks";
import {BasketAddRemove} from "..";


const imageParamss = {
    slidesPerView: 'auto',
    spaceBetween: 50,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
}


function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}

function limitText(txt,length) {
    if(txt.length>length){
        return txt.substr(0,length)+" ... "
    }else {
        return txt
    }
}

function OnlineOff({list,merchantId}) {
    //hooks
    const history = useHistory();

    return(
        // <span>swiper ...</span>
        <div className="online-off-section" style={{
            backgroundColor: "#ca3232",
            margin: 8,
            padding: 8,
        }}>
            {list && list.selective_products.length>0? <SwiperId {...imageParamss}>
                <div className="swiper-card-container off-card">
                    <div className="swiper-card-body">
                        <span>تخفیف</span>
                        <span>ویژه</span>
                    </div>
                </div>
                {list.selective_products.map(item=>{
                    return(
                        <div style={{width:100}}>
                            <div className="swiper-card-container">
                                <div className="swiper-card-body" >
                                    <BasketAddRemove item={item}/>
                                    <div onClick={()=>{
                                        history.push(`/online-store-product/${merchantId}/${item.uid}`)
                                    }}>
                                        <img src={item.image} alt=""/>
                                    </div>
                                </div>
                                <div className="price-section">
                                    <div className="price">
                                        {numberWithCommas(item.price)} ریال
                                    </div>
                                    {item.price_original-item.price>0?<div className="price-without-off">
                                        {numberWithCommas(item.price_original)}
                                    </div>:null}
                                </div>
                                {item && item.discount_percentage!==0?
                                    <div className="off">
                                        <span>{item.discount_percentage+" % "}</span>
                                    </div>:null
                                }

                                <div className="info-section">
                                    <div className="name">{limitText(item.name,25)}</div>
                                    {/*<div className="weight">1500 گرمی میهن</div>*/}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </SwiperId>:null}
        </div>
    )
}

export {OnlineOff};
